import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      home: "Home",
      projects: "Projects",
      franchise: "Franchise",
      community: "Community",
      career: "Career",
      contact: "Contact",
      ar: "العربية",
      en: "EN",
      freelancers: "Freelancers",
      developers: "Developers",
      news: "News",
      type: "Type",
      location: "Location",
      search_location: "Search Location",
      keyword: "Keyword",
      search_keyword: "Search Keyword",
      search_advance: "Search Advanced",
      search: "Search",
      consultation_request: "Consultation Request",
      consultation_request_detail: "Fill out the form, and a property consultant will get in touch with you.",
      name: "Name",
      name_placeholder: "Enter Your Name",
      phone: "Phone",
      phone_placeholder: "Enter Phone Number",
      message_optional: "Message (optional)",
      message_placeholder: "Enter Your Message",
      submit: "Submit",
      contact_details: "Contact Details",
      working_hours: "Working Hours",
      area: "Area",
      properties_available: "Properties Available",
      view_more: "View More",
      whatsapp: "WhatsApp",
      call_us: "Call Us",
      banner_desc: "We would love to hear from you!",
      property: "Property",
      price_start: "Price Starts From",
      book_now: "Book now",
      know_more: "Know more",
      openings: "Openings",
      address: "Address",
      cookies1: "We use",
      cookies2: "cookies to improve your experience. By continuing, you agree to our",
      privacy_policy: "Privacy Policy",
      accept: "Accept",
      decline: "Decline",
      per_sqft: "per m²",
      beds: "Beds",
      baths: "Baths",
      sqft: "sqft",
      Metersq: "m²",
      property_not_found: "Property Not found",
      opps: "Opps!",
      view_all_properties: "View all properties",
      project_statuses: "Project Status",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      payments: "Payments",
      egp: "EGP",
      aed: "AED",
      minimum_payment: "Minimum Payment",
      maximum_payment: "Maximum Payment",
      min_amount: "Min Amount",
      max_amount: "Max Amount",
      property_area: "Property Area",
      minimum_area: "Minimum Area",
      min_area: "Min Area",
      maximum_area: "Maximum Area",
      max_area: "Max Area",
      amenities: "Amenities",
      property_types: "Property Types",
      reset_all: "Reset all",
      recent_posts: "Recent posts",
      tags: "Tags",
      follow_us: "Follow Us",
      about_us: "About us",
      area_details: "Area Details",
      banner_desc_career: "Connect Homes has different departments that you can explore and unleash your potential",
      offer: "Offers",
      get_offer: "Get offer",
      and_know_more: "and know more",
      project_available: "Project Available",
      freelance_header: "Get connected and stay productive!",
      freelance_desc: "Download our app today for seamless access to all features and updates, right at your fingertips.",
      apartment: "Apartment",
      bungalow: "Bungalow",
      service_apartments: "Service Apartments",
      duplex: "Duplex",
      penthouse: "Penthouse",
      villa: "Villa",
      office: "Office",
      clinic: "Clinic",
      studio: "Studio",
      chalet: "Chalet",
      retail: "Retail",
      twinhouse: "Twinhouse",
      townhouse: "Townhouse",
      delivery_in: "Delivery In",
      sale_type: "Sale Type",
      project: "Project",
      project_status: "Project Status",
      property_view: "Property View",
      floor_plan: "Floor Plan",
      master_plan: "Master Plan",
      view_on_map: "View on Map",
      gallery: "Gallery",
      home_facts: "Home Facts",
      built_in: "Built in",
      price_summary: "Price Summary",
      about: "About",
      smart_location: "The smart location of",
      contact_desc: "Move Now, Pay Later with Connect Home Now! Don’t wait—secure your future today!",
      new_listings: "New Listings",
      property_details: "Property Details",
      image_not_found: "Image Not found",
      phone_required: "Phone number is required",
      name_required: "Name is required",
      apply_for: "Apply for",
      email: "Email",
      resume: "Resume",
      browse: "Browse",
      delivery_years: "Delivery Years",
      position_required: "Position is required",
      email_required: "Valid email address is required",
      file_required: "Valid resume is required",
      apply_now: "Apply now",
      position_placeholder: "Enter Position",
      email_placeholder: "Enter Your Email",
      copy_message: "Copied! You can now share the Property.",
      something_went_wrong: "Something went wrong",
      property_name: "Property Name",
      is: "is",
      advance_search: "Advance Search",
      faq: "FAQ",
      privacypolicy: "Privacy Policy",
      termsandconditions: "Terms And Conditions",
      clubhouse: "Clubhouse",
      schools: "Schools",
      commercial_strip: "Commercial Strip",
      sports_clubs: "Sports Clubs",
      mosque: "Mosque",
      bicycles_lanes: "Bicycles Lanes",
      planned: "Planned",
      upcoming: "Upcoming",
      ongoing: "Ongoing",
      completed: "Completed",
      career_banner_des: "At Connect Homes, we believe our people are our greatest asset. That’s why we’ve created an environment where growth, support, and well-being come first.",
      benefits: "Benefits",
      career_benefit: "Working at Connect Homes has several perks.",
      load_more: "Load More",
      news_not_found: "News Not found",
      dev_not_found: "Developer Not found",
      dev_project_not_found: "Developer's Project Not found",
      about_us_title_part: "The Reason for love Contact Home Page",
      about_us_part1: "Whether you’re looking for a family home on a leafy avenue or seeking investment opportunities, we’ll give you the exceptional customer service that comes with over 10 years of experience.",
      about_us_part2: "Connect Homes is a real estate agency that offers a decade of experience in housing solutions. We believe true success is about giving forward. We go above and beyond for our clients. We believe that everyone deserves a place to call home, and the opportunity to pursue their hopes and dreams.",
      about_us_part3: "Connect Homes’s outstanding reputation and track record of success provides clients with a trusted resource, assuring our clients that optimum service quality will always be provided.",
      award_winning: "Award Winning",
      happy_customer: "Happy Customer",
      property_ready: "Property Ready",
      franchise_content_1: "Join a culture that thrives on success, support, and shared growth.",
      franchise_content_2: "At Connect Homes, you're not just opening a franchise — you're joining a community. We’ve built a positive, performance-driven environment where collaboration and ambition go hand in hand.",
      franchise_content_3: "Built for entrepreneurs, powered by experience.",
      franchise_content_4: "With over a decade of real estate expertise, we offer you a proven business model, industry-leading training, and continuous support to help you scale fast and smart.",
      franchise_content_5: "Profit with purpose.",
      franchise_content_6: "Our franchisees enjoy real financial rewards, backed by strong brand trust and high client satisfaction. Whether you're starting out or scaling up, Connect Homes is designed to grow with you.",
      franchise_content_7: "Your success is our blueprint.",
      franchise_content_8: "From marketing tools to operational guidance, we're with you every step of the way — because when you win, we all win.",
      price_to: "Price To",
      payment_plan: "Payment Plan",
      new_launch: "New Launch",
      master_plan_features: "The Master Plan Features",
      property_listings: "Property Listings",
      sale_types: "Sale Types",
      developer_sale: "Developer Sale",
      off_plan: "Off-Plan",
      resale: "Resale",
      offer_not_found: "Offer Not found",
      search_developer: "Search Developer",
      clear: "Clear"



    },
  },
  ar: {
    translation: {
      home: "الرئيسية",
      projects: "المشاريع",
      franchise: "فرانشايز",
      community: "مجتمع",
      career: "وظائف",
      contact: "تواصل معنا",
      ar: "العربية",
      en: "EN",
      freelancers: "فريلانسر",
      developers: "المطورين",
      news: "الاخبار",
      type: "نوع الوحدة",
      location: "الموقع",
      search_location: "بحث الموقع",
      keyword: "كلمة دلالية",
      search_keyword: "كلمة البحث",
      search_advance: "بحث متقدم",
      search: "بحث",
      consultation_request: "طلب استشارة عقارية",
      consultation_request_detail: "املأ الاستمارة الاتية  وسيقوم احد مستشارينا بالاتصال بكم",
      name: "الاسم",
      name_placeholder: "اسمك",
      phone: "الهاتف",
      phone_placeholder: "رقم الهاتف",
      message_optional: "الرسالة (اختياري)",
      message_placeholder: "ادخل استفسارك",
      submit: "ارسال",
      contact_details: "طريقة التواصل",
      working_hours: "ساعات العمل",
      area: "مساحة",
      properties_available: "الوحدات المتاحة",
      view_more: "إعرض المزيد",
      whatsapp: "واتس اب",
      call_us: "تواصل معنا",
      banner_desc: "نحن نحب أن نسمع منك!",
      property: "وحدة",
      price_start: "السعر يبدأ من ",
      book_now: "إحجز الآن",
      know_more: "أعرف المزيد",
      openings: "متاح",
      address: "عنوان",
      cookies1: "نحن نستخدم",
      cookies2: "ملفات تعريف الارتباط لتحسين تجربتك. بالمتابعة، فإنك توافق على شروط الاستخدام الخاصة بنا.",
      privacy_policy: "سياسة الخصوصية",
      accept: "قبول ",
      decline: "رفض",
      per_sqft: "لكل م²",
      beds: "غرف",
      baths: "حمام",
      sqft: "متر مربع ",
      Metersq: "م²",
      property_not_found: "لم يتم العثور على الوحدة",
      opps: "Opps!",
      view_all_properties: "عرض جميع الوحدات",
      project_statuses: "حالة المشروع ",
      bedrooms: "غرف نوم ",
      bathrooms: "حمام",
      payments: "المدفوعات",
      egp: "جم",
      aed: "AED",
      minimum_payment: "الحد الأدنى للدفع",
      maximum_payment: "الحد الأقصى للدفع",
      min_amount: "الحد الأدنى للمبلغ",
      max_amount: "الحد الأقصى للمبلغ",
      property_area: "مساحة العقار",
      minimum_area: "الحد الأدنى للمساحة ",
      min_area: "الحد الأدنى للمساحة ",
      maximum_area: "الحد الأقصى للمساحة",
      max_area: "الحد الأقصى للمساحة",
      amenities: "وسائل الراحة",
      property_types: "نوع العقار",
      reset_all: "إعادة ضبط الكل",
      recent_posts: "المنشورات الأخيرة",
      tags: "العلامات",
      follow_us: "تابعنا ",
      about_us: "معلومات عنا",
      area_details: "تفاصيل المساحة",
      banner_desc_career: "تحتوي شركة Connect Homes على أقسام مختلفة يمكنك استكشافها و ابداء العمل معنا.",
      offer: "عروض ",
      get_offer: "أحصل على العرض",
      and_know_more: "و معرفة المزيد",
      project_available: "المشروع المتاح",
      freelance_header: "تواصل معنا وابقَ منتجًا!",
      freelance_desc: "قم بتنزيل تطبيقنا اليوم للوصول بسهولة إلى جميع المميزات والتحديثات، مباشرة في متناول يدك.",
      apartment: "شقه",
      bungalow: "جناح",
      service_apartments: "شقق فندقية",
      duplex: "دوبليكس",
      penthouse: "بنتا هاوس",
      villa: "فيلا",
      office: "مكتب اداري",
      clinic: "عياده",
      studio: "استوديو",
      chalet: "شاليه",
      retail: "محل تجاري",
      twinhouse: "توين هاوس",
      townhouse: "تاون هاوس",
      delivery_in: "ميعاد التسليم",
      sale_type: "نوع العقار",
      project: "مشروع ",
      project_status: "حاله المشروع",
      property_view: "عرض الوحدة ",
      floor_plan: "خريطة الوحدة",
      master_plan: "خريطة المشروع ",
      view_on_map: "عرض على الخريطة ",
      gallery: "معرض",
      home_facts: "معلومات عن الوحدة ",
      built_in: "سنة البناء",
      price_summary: "ملخص السعر",
      about: "حول",
      smart_location: "الموقع المتميز ",
      contact_desc: "إختار الآن، وادفع لاحقًا مع خدمة Connect Homes Now! لا تنتظر، اضمن مستقبلك اليوم!",
      new_listings: "عروض آخرى ",
      property_details: "تفاصيل الوحدة ",
      image_not_found: "الصورة غير متوفرة ",
      phone_required: "مطلوب رقم الهاتف ",
      name_required: "مطلوب الاسم",
      apply_for: "قدم على",
      email: "البريد الاإكتروني",
      resume: "السيرة الذاتية",
      browse: "تصفح",
      delivery_years: "سنوات التسليم",
      position_required: "المنصب مطلوب",
      email_required: "يجب إدخال عنوان بريد إلكتروني صالح",
      file_required: "مطلوب سيرة ذاتية حديثة",
      apply_now: "قدم طلبك الآن",
      position_placeholder: "أدخل المنصب",
      email_placeholder: "أدخل بريدك الإلكتروني",
      copy_message: "تم النسخ! يمكنك الآن مشاركة الوحدة.",
      something_went_wrong: "حدث خطأ ما",
      property_name: "اسم العقار",
      is: "هو",
      advance_search: "بحث متطور",
      faq: "الاسئلة الاكثر شيوعا ",
      privacypolicy: "سياسة الخصوصية",
      termsandconditions: "الشروط و الأحكام",
      clubhouse: "النادي",
      schools: "مدارس",
      commercial_strip: "خدمات تجارية",
      sports_clubs: "نادي رياضي",
      mosque: "مسجد",
      bicycles_lanes: "مسار دراجات",
      planned: "مخطط",
      upcoming: "القادم",
      ongoing: "مستمر",
      completed: "مكتمل",
      career_banner_des: "في Connect Homes، نؤمن بأن فريق العمل هو أعظم ما نملك. لذلك حرصنا على بناء بيئة ترتكز على النمو، والدعم، والاهتمام بالراحة النفسية والرفاهية في المقام الأول",
      benefits: "المزايا التي نقدمها",
      career_benefit: "العمل في Connect Homes يتميّز بعدة امتيازات ومزايا.",
      load_more: "حمل المزيد",
      news_not_found: "الأخبار لم يتم العثور عليها",
      dev_not_found: "لم يتم العثور على المطور",
      dev_project_not_found: "لم يتم العثور على مشروع المطور",
      about_us_title_part: "سبب الحب الاتصال بالصفحة الرئيسية",
      about_us_part1: "في Connect Homes، نضع بين يديك خبرة تتجاوز عشر سنوات في تقديم الحلول العقارية المتكاملة. سواء كنت تبحث عن منزل عائلي في شارع هادئ تحيطه الأشجار، أو تسعى لفرصة استثمارية مميزة، فإننا نضمن لك خدمة استثنائية تقوم على الاحترافية والاهتمام بالتفاصيل.",
      about_us_part2: "نحن نؤمن أن النجاح الحقيقي لا يقتصر على الإنجاز، بل يمتد إلى العطاء. لهذا، نحرص دائماً على تجاوز توقعات عملائنا، ونسعى لأن نكون شركاء حقيقيين في رحلتهم نحو امتلاك المسكن المثالي أو الاستثمار الناجح. نحن نؤمن بأن لكل فرد الحق في امتلاك مكان يشعر فيه بالانتماء، ويحقق من خلاله أحلامه وطموحاته.",
      about_us_part3: "لقد أسست Connect Homes سمعة راسخة وسجلًا من النجاحات في السوق العقاري، ما يجعلنا خيارًا موثوقًا لعملائنا، ويمنحهم الثقة بأنهم في أيدٍ خبيرة تقدم أعلى معايير الجودة في كل خطوة.",
      award_winning: "حائز على جائزة",
      happy_customer: "عميل سعيد",
      property_ready: "عقار جاهز",
      franchise_content_1: "انضم إلى ثقافة تزدهر بالنجاح والدعم والنمو المشترك",
      franchise_content_2: "في كونيكت هومز، أنت لا تفتتح امتيازًا تجاريًا فحسب، بل تنضم إلى مجتمع متكامل. لقد بنينا بيئة عمل إيجابية، قائمة على الأداء، حيث يتكامل التعاون والطموح.",
      franchise_content_3: "مُصمم خصيصًا لرجال الأعمال، ومدعوم بالخبرة.",
      franchise_content_4: "مع أكثر من عقد من الخبرة في مجال العقارات، نقدم لك نموذج أعمال مثبتًا، وتدريبًا رائدًا في الصناعة، ودعمًا مستمرًا لمساعدتك على التوسع بسرعة وذكاء.",
      franchise_content_5: "الربح مع الهدف.",
      franchise_content_6: "يتمتع أصحاب امتيازاتنا بمكافآت مالية حقيقية، مدعومين بثقة راسخة بالعلامة التجارية ورضا عملاء عالٍ. سواءً كنتَ في بداية مشروعك أو في طور التوسع، فإن كونكت هومز مصممة لتنمو معك.",
      franchise_content_7: "نجاحك هو مخططنا.",
      franchise_content_8: "من أدوات التسويق إلى التوجيه التشغيلي، نحن معك في كل خطوة على الطريق - لأنه عندما تفوز، نفوز جميعًا.",
      price_to: "السعر إلى",
      payment_plan: "خطة الدفع",
      new_launch: "إطلاق جديد",
      master_plan_features: "ميزات الخطة الرئيسية",
      property_listings: "قوائم العقارات",
      sale_types: "أنواع المبيعات",
      developer_sale: "بيع المطور",
      off_plan: "على الخارطة",
      resale: "إعادة البيع",
      offer_not_found: "العرض غير موجود",
      search_developer: "بحث المطورين",
      clear: "واضح"


    },
  },
};

i18n
  .use(LanguageDetector) // Use the language detector
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "", // Default language
    supportedLngs: ["en", "ar"],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["path", "navigator"], // Priority: check the path first, then the browser language
      caches: ["localStorage"], // Optional: cache the user's language in localStorage
      lookupFromPathIndex: 1, // Look at the first segment of the URL path
    },
    // hide 'en' in paths
    cleanCode: true,
    returnObjects: true,
  });

export default i18n;
